export var AuthPagesSubject;
(function (AuthPagesSubject) {
    AuthPagesSubject["EmailField"] = "email-field";
    AuthPagesSubject["PasswordField"] = "password-field";
    AuthPagesSubject["FullNameField"] = "full-name-field";
    AuthPagesSubject["CompanyField"] = "company-field";
    AuthPagesSubject["PhoneField"] = "phone-field";
    AuthPagesSubject["RegionField"] = "region-field";
    AuthPagesSubject["Passcode"] = "passcode";
    AuthPagesSubject["SignInButton"] = "sign-in-button";
    AuthPagesSubject["SignUpButton"] = "sign-up-button";
    AuthPagesSubject["ForgotPasswordButton"] = "forgot-password-button";
    AuthPagesSubject["BackToLoginLink"] = "back-to-login-link";
    AuthPagesSubject["LoginPage"] = "login-page";
    AuthPagesSubject["ForgotPasswordPage"] = "forgot-password-page";
    AuthPagesSubject["RegisterPage"] = "register-page";
    AuthPagesSubject["AuthPage"] = "auth-page";
    AuthPagesSubject["FormErrorMessage"] = "form-error-message";
})(AuthPagesSubject || (AuthPagesSubject = {}));
export var AuthNotificationSubject;
(function (AuthNotificationSubject) {
    AuthNotificationSubject["SsoRedirect"] = "sso-redirect";
    AuthNotificationSubject["PasswordChanged"] = "password-changed";
})(AuthNotificationSubject || (AuthNotificationSubject = {}));
export var LoginPageState;
(function (LoginPageState) {
    LoginPageState["App360AccountAuthSettingsSwitch"] = "360-account-auth-settings-switch";
})(LoginPageState || (LoginPageState = {}));
//# sourceMappingURL=auth.enum.js.map